export var InvoiceType;
(function (InvoiceType) {
    /** Universal transfer document */
    InvoiceType[InvoiceType["Utd1"] = 1] = "Utd1";
    InvoiceType[InvoiceType["Utd2"] = 2] = "Utd2";
    InvoiceType[InvoiceType["Return"] = 3] = "Return";
})(InvoiceType || (InvoiceType = {}));
